import { getCookies } from './document.cookie';
import { getQueryFromWindow } from './window.query';

const FP_SESSION_COOKIE = 'fp_prof_profileid';
const LEGACY_COOKIE = 'prof_profileid';
const ESTABLISH_URL = process.env.REACT_APP_ESTABLISH_URL!;
const HOME_REDIRECT_URL = process.env.REACT_APP_HOME_REDIRECT_URL!;

const halt = () => new Promise<void>(() => { /* never resolves; redirect in flight */ });

// HOME_REDIRECT_URL points at the SPA's own /login (e.g. personal.fiscalpop.com/login),
// so the no-identity fallback would loop on auth pages without this guard.
const isAuthPath = (pathname: string) =>
    pathname === '/login' ||
    pathname.startsWith('/login/') ||
    pathname === '/register' ||
    pathname.startsWith('/register/') ||
    pathname === '/recover' ||
    pathname.startsWith('/recover/') ||
    pathname.startsWith('/reset/') ||
    pathname === '/register-incomplete'

export async function bootstrapSession(): Promise<void> {
    const query = getQueryFromWindow();
    const cookies = getCookies();

    // Account-switch landed here with legacy query — forward to establish, BE mints cookie and 302s back.
    if (query[LEGACY_COOKIE]) {
        window.location.replace(`${ESTABLISH_URL}${window.location.search}`);
        return halt();
    }

    // Cookie present → SPA boots directly. Drop the legacy backup; cookie is source of truth from here.
    if (cookies[FP_SESSION_COOKIE]) {
        localStorage.removeItem(LEGACY_COOKIE);
        return;
    }

    // Migrate any leftover legacy cookie / localStorage token via establish.
    // (Storage first due to account switch, cookie after)
    const legacyB64 = localStorage.getItem(LEGACY_COOKIE) || cookies[LEGACY_COOKIE];
    if (legacyB64) {
        const raw = atob(legacyB64);
        // Drop the backup pre-redirect so a failing establish can't loop us back through this branch.
        localStorage.removeItem(LEGACY_COOKIE);
        window.location.replace(`${ESTABLISH_URL}?${LEGACY_COOKIE}=${encodeURIComponent(raw)}`);
        return halt();
    }

    if (isAuthPath(window.location.pathname)) {
        return;
    }

    // No identity at all — same fallback App.tsx uses on auth failure.
    window.location.replace(HOME_REDIRECT_URL);
    return halt();
}
